module.exports = __webpack_public_path__ + "img/service-professional-services-3.5a3a71b7.jpg";